import { findTaskPanesByWindow } from 'owa-addins-store/lib/utils/taskPaneUtils';
import { getAdapter } from 'owa-addins-adapters/lib/adapters/AdapterManager';
import type { MailboxInfo } from 'owa-client-types';
import trace from 'owa-trace/lib/trace';

/**
 * Gets the MailboxInfo associated with the given window by looking up any add-in task panes running in that window.
 * Returns undefined if no task panes or MailboxInfo can be found for the window.
 * @param targetWindow The window for which to get the MailboxInfo.
 * @returns The MailboxInfo associated with the given window, or undefined if it cannot be found.
 */
export function getAddinMailboxInfoForWindow(targetWindow: Window): MailboxInfo | undefined {
    const taskPanes = findTaskPanesByWindow(targetWindow);
    if (!taskPanes) {
        trace.warn('No addin task panes found for the given window');
        return undefined;
    }
    for (const instance of taskPanes.values()) {
        if (instance) {
            const adapter = getAdapter(instance.hostItemIndex);
            return adapter?.getMailboxInfo();
        }
    }
    return undefined;
}
